import React from "react";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import Home from "../pages/home/HomeComponent";
import Education from "../pages/education/EducationComponent";
import Experience from "../pages/experience/Experience";
import Projects from "../pages/projects/Projects";
import Footer from "../components/footer/Footer";

const Main = (props) => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/sde" />} />
          <Route path="/:role" element={<Home />} />
          <Route path="/:role/experience" element={<Experience {...props} />} />
          <Route path="/:role/education" element={<Education {...props} />} />
          <Route path="/:role/projects" element={<Projects {...props} />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </>
  );
};

export default Main;
